import {Component, OnInit} from '@angular/core';
import {RouterOutlet} from "@angular/router";
import {ToastModule} from "primeng/toast";
import {SharedModule} from "./shared/shared.module";
import {AuthenticationService} from "./service/authentication-service";
import {PrivilegeService} from "./service/privilege.service";
import {PrimeNG} from "primeng/config";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [RouterOutlet, ToastModule, SharedModule]
})
export class AppComponent implements OnInit {

  constructor(
    private primeNG: PrimeNG,
    private authService: AuthenticationService,
    private privilegeService: PrivilegeService
  ) {
  }

  ngOnInit() {
    this.authService.autoLogin()
    this.privilegeService.updateRole()
    this.loadPrimeNgTranslations()
  }

  loadPrimeNgTranslations() {
    this.primeNG.setTranslation(
      {
        apply: 'Aplicar',
        clear: 'Limpar',
        accept: 'Sim',
        reject: 'Não',
        firstDayOfWeek: 0,
        dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
        dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
        monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho',
          'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        today: 'Hoje'
      }
    )
  }
}
